import React from "react";

interface CashRow {
  order_id: string | number;
  order_total: number;
  order_quantity: number;
  table: string | number | null;
  mycia_commission: number;
  created_at: string;
}

interface Props {
  rows: CashRow[];
}

const CashDetailTable: React.FC<Props> = ({ rows }) => {
  if (!rows || rows.length === 0) {
    return <p className="text-xs text-gray-500">Nessuna transazione trovata.</p>;
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-xs border rounded">
        <thead className="bg-mcia_orange text-white hover:text-black">
          <tr>
            <th className="px-2 py-1 text-left">Ordine ID</th>
            <th className="px-2 py-1 text-left">Totale</th>
            <th className="px-2 py-1 text-left">Quantità</th>
            <th className="px-2 py-1 text-left">Tavolo</th>
            <th className="px-2 py-1 text-left">Commissione MyCIA</th>
            <th className="px-2 py-1 text-left">Data</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((t) => (
            <tr key={String(t.order_id)} className="border-t odd:bg-white even:bg-gray-200">
              <td className="px-2 py-1">{t.order_id}</td>
              <td className="px-2 py-1">€ {t.order_total.toFixed(2)}</td>
              <td className="px-2 py-1">{t.order_quantity}</td>
              <td className="px-2 py-1">{t.table}</td>
              <td className="px-2 py-1">€ {t.mycia_commission.toFixed(2)}</td>
              <td className="px-2 py-1">{t.created_at}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CashDetailTable;
